module.exports = __webpack_public_path__ + "img/icon-smile.279403d9.svg";